import axios from 'axios';
import env from '../config/env.js';

// ✅ Configuração da API
const getApiBaseUrl = () => {
  const NODE_ENV = process.env.NODE_ENV || 'development';

  if (NODE_ENV === 'production' || NODE_ENV === 'homolog' || NODE_ENV === 'staging') {
    return '/api';
  }

  // Em desenvolvimento, usar URL completa do backend
  if (process.env.REACT_APP_API_BASE_URL) {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    return apiUrl.endsWith('/api') ? apiUrl : `${apiUrl}/api`;
  }

  // Fallback para desenvolvimento: usar localhost:3001
  return 'http://localhost:3001/api';
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: parseInt(env.API_TIMEOUT),
  headers: {
    'accept': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    // ✅ Lista de rotas públicas que NÃO precisam de token
    const publicRoutes = [
      'auth/login',
      'auth/forgot-password',
      'auth/reset-password'
    ];

    const url = String(config.url || '').toLowerCase().trim();
    const baseURL = String(config.baseURL || '').toLowerCase().trim();
    const fullUrl = (baseURL + url).toLowerCase();

    const isPublicRoute = publicRoutes.some(route => {
      return fullUrl.includes(route) || url.includes(route);
    });

    if (isPublicRoute) {
      delete config.headers.Authorization;
    } else if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ✅ HEADER OBRIGATÓRIO PARA TODAS AS REQUISIÇÕES
    config.headers['x-second-key'] = env.SECOND_SECRET_KEY;

    if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      return Promise.reject(new Error("O servidor demorou muito para responder. Por favor, tente novamente."));
    }

    if (error.response) {
      const isPublicRoute = error.config?.url?.toLowerCase().includes('auth/login');

      if ((error.response.status === 401 || error.response.status === 403) && !isPublicRoute) {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');

        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }

      return Promise.reject({
        ...error.response.data,
        status: error.response.status,
        response: error.response
      });
    }

    if (error.request) {
      // Erro de rede (sem resposta do servidor)
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
        return Promise.reject(new Error("Não foi possível conectar ao servidor. Verifique se o backend está rodando."));
      }
      return Promise.reject(new Error("Não foi possível conectar ao servidor. Verifique sua conexão."));
    }

    return Promise.reject(error);
  }
);

export default api;

